export enum IssueClassificationEnum {
  DEFICIENCY = 'deficiency',
  RECOMMENDATION = 'recommendation',
}

export type IssueClassificationType = `${IssueClassificationEnum}`;
